import {ButtonSize, ButtonVariant} from './types';

export const variantClasses: Record<ButtonVariant, string> = {
	fill: 'bg-skin-button-fill text-skin-inverted hover:bg-skin-button-fill-hover active:bg-skin-button-fill-active disabled:bg-skin-button-fill-muted disabled:text-skin-inverted-muted',
	tonal:
		'bg-skin-button-tonal hover:bg-skin-button-tonal-hover active:bg-skin-button-tonal-active disabled:bg-skin-button-tonal-muted disabled:text-skin-muted',
	ghost: 'text-skin-muted hover:bg-skin-ghost-hover active:bg-skin-ghost-active disabled:text-skin-muted',
	inverted:
		'bg-skin-button-inverted text-skin-inverted hover:bg-skin-button-inverted-hover active:bg-skin-button-inverted-active',
	white: 'bg-white hover:bg-skin-button-tonal-hover',
};

export const sizeClasses: Record<
	ButtonSize,
	{
		height: string;
		width: string;
		px: string;
		compensation: string;
		icon: {sizes: string; padding: string};
	}
> = {
	xs: {width: 'w-6', height: 'h-6', px: 'px-1', compensation: 'mx-0.5', icon: {sizes: 'w-4 h-4', padding: 'p-0.5'}},
	sm: {width: 'w-8', height: 'h-8', px: 'px-1.5', compensation: 'mx-0.5', icon: {sizes: 'w-5 h-5', padding: 'p-0.5'}},
	md: {width: 'w-10', height: 'h-10', px: 'px-2', compensation: 'mx-1', icon: {sizes: 'w-5 h-5', padding: 'p-0.5'}},
	lg: {width: 'w-14', height: 'h-14', px: 'px-4', compensation: 'mx-1.5', icon: {sizes: 'w-5 h-5', padding: 'p-0.5'}},
	mobile: {
		width: 'w-10',
		height: 'h-13',
		px: 'px-4',
		compensation: 'mx-1.5',
		icon: {sizes: 'w-10 h-5', padding: 'p-0.5'},
	},
};
